var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{style:(_vm.background),attrs:{"id":"base"}},[_c('v-main',{attrs:{"app":""}},[_c('router-view')],1),_c('FooterTransparent',{staticStyle:{"backgroundcolor":"transparent"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }